// eslint-disable-next-line @typescript-eslint/no-var-requires
const { captureException } = require('@sentry/nextjs');

const REDIS_URL = `redis://${process.env.REDIS_HOST}`;
const REDIS_PREFIX = `${process.env.REDIS_PREFIX}:fe:translates:`;
const REDIS_UPDATE_JOB_TIMEOUT = 5; // seconds (default: 30)
const REDIS_ENTRY_TTL = 10800; // seconds (default: none)

const logException = (e) => {
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error(e);
    }

    captureException(e);
};

module.exports = {
    pages: {
        '*': ['common'],
    },
    locales: ['cs', 'pl', 'en', 'sk', 'hu', 'de', 'de-AT', 'es', 'it', 'pt'],
    defaultLocale: 'cs',
    localeDetection: false,
    serializeConfig: false,
    defaultNS: 'common',
    logBuild: process.env.NODE_ENV !== 'production',
    keySeparator: false,
    nsSeparator: false,
    loader: false,
    skipInitialProps: true,
    loaderName: 'getServerSideProps',
    loadLocaleFrom: async (locale, namespace) => {
        let redisClient;
        try {
            if (typeof window === 'undefined') {
                const redis = await import('redis');
                const redisKey = `${REDIS_PREFIX}${locale}:${namespace}`;

                redisClient = redis.createClient({
                    url: REDIS_URL,
                    socket: {
                        connectTimeout: 5000,
                        reconnectStrategy: () => new Error('The Redis server refused the connection.'),
                    },
                });

                await redisClient.connect();

                const [cachedTranslates, updateJobIsRunning] = await redisClient.mGet([
                    redisKey,
                    redisKey + '/updating',
                ]);

                if (cachedTranslates === null && updateJobIsRunning === null) {
                    const cacheToRedis = async () => {
                        const setUpdatingFlag = await redisClient.set(redisKey + '/updating', 'true', {
                            NX: true,
                            EX: REDIS_UPDATE_JOB_TIMEOUT,
                        });

                        if (setUpdatingFlag !== null) {
                            const getTranslates = (await import('./i18n-translator')).getFreshTranslates;
                            const freshTranslates = await getTranslates(locale, namespace);
                            const translatesToCache = JSON.stringify(freshTranslates);

                            if (translatesToCache) {
                                await Promise.all([
                                    redisClient.set(redisKey, translatesToCache, {EX: REDIS_ENTRY_TTL}),
                                ]);
                            }
                        }
                    };

                    await cacheToRedis().catch((reject) => {
                        logException(reject);
                    });
                }

                await redisClient.disconnect();
                if (cachedTranslates !== null) {
                    return JSON.parse(cachedTranslates);
                }
            }
        } catch (error) {
            logException(error);
        } finally {
            if (redisClient?.isOpen) {
                await redisClient.disconnect();
            }
        }

        return (await import('./i18n-translator')).getFreshTranslates(locale, namespace);
    },
};
